import React from 'react';
import { AlertTriangle } from 'lucide-react';
import './UserFormCoordinatorUnlinkModal.css';

/**
 * Aviso bloqueante ao sair do tipo Técnico com OS em LCMY_ASSTEC02.
 */
export function UserFormTechnicianOsBlockModal({
  message,
  orderNumbers = [],
  totalCount = 0,
  title = 'Operação bloqueada',
  onClose,
}) {
  const list = Array.isArray(orderNumbers) ? orderNumbers.filter(Boolean) : [];
  const total = Number(totalCount) || list.length;
  if (!message && list.length === 0) return null;

  return (
    <div className="uf-coord-unlink-overlay" role="dialog" aria-modal="true" aria-labelledby="uf-tech-os-title">
      <div className="uf-coord-unlink-modal">
        <div className="uf-coord-unlink-icon" aria-hidden>
          <AlertTriangle size={22} strokeWidth={1.75} />
        </div>
        <h3 id="uf-tech-os-title" className="uf-coord-unlink-title">
          {title}
        </h3>
        <p className="uf-coord-unlink-lead">
          Não é possível alterar ou excluir este técnico enquanto houver ordens de serviço
          vinculadas a ele. Redistribua as OS para outro técnico antes de continuar.
        </p>
        {list.length > 0 ? (
          <div className="uf-tech-os-block">
            <div className="uf-tech-os-block-label">
              {total} OS vinculada{total === 1 ? '' : 's'}
              {list.length < total ? ` (exibindo ${list.length})` : ''}
            </div>
            <div className="uf-tech-os-block-list">{list.join(', ')}</div>
          </div>
        ) : message ? (
          <ul className="uf-coord-unlink-list">
            <li>{message}</li>
          </ul>
        ) : null}
        <div className="uf-coord-unlink-actions">
          <button
            type="button"
            className="user-form-profile-save-btn user-form-footer-btn"
            onClick={onClose}
          >
            Entendi
          </button>
        </div>
      </div>
    </div>
  );
}
